import DraggableBox from './DraggableBox';

export default DraggableBox;
